<template>
  <b-card class="lead-source-roi" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <b-card-body>
      <b-table :items="leadSourceRoiData" :fields="fields" per-page="5" small striped responsive></b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'LeadSourceRoi',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },

  data() {

    return {

      fields: [
        { key: 'source_name', label: 'Lead Source' },
        { key: 'total_revenue', label: 'Total Revenue' },
        { key: 'lead_source_cost', label: 'Total Cost' },
        { key: 'roi', label: 'ROI' }
      ],
      leadSourceRoiData: [],

    };

  },

  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.lead_source_roi != null && hasRight(this.user, 'dashboard', 'view')) {
          this.leadSourceRoiData = Array.isArray(val.lead_source_roi) ? [...val.lead_source_roi] : [];
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.lead_source_roi != null) this.leadSourceRoiData = Array.isArray(this.dashboardData.lead_source_roi) ? [...this.dashboardData.lead_source_roi] : [];
          return;
        }
        if (this.dashboardData && this.dashboardData.lead_source_roi != null) { this.leadSourceRoiData = Array.isArray(this.dashboardData.lead_source_roi) ? [...this.dashboardData.lead_source_roi] : []; return; }
        this.fetchLeadSourceRoiData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.lead_source_roi != null) this.leadSourceRoiData = Array.isArray(this.dashboardData.lead_source_roi) ? [...this.dashboardData.lead_source_roi] : [];
            return;
          }
          this.fetchLeadSourceRoiData();
        } else {
          this.leadSourceRoiData = [];
        }
      },
    },
  },

  methods: {

    hasRight, // Make the helper available in the template

    async fetchLeadSourceRoiData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.lead_source_roi != null)) {
        if (this.dashboardData && this.dashboardData.lead_source_roi != null) this.leadSourceRoiData = Array.isArray(this.dashboardData.lead_source_roi) ? [...this.dashboardData.lead_source_roi] : [];
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/lead-source-roi', this.filters);
        const raw = response.data && response.data.data;
        this.leadSourceRoiData = Array.isArray(raw) ? [...raw] : [];

      } catch (error) {

        console.error('Error fetching lead source ROI data:', error);

        // Handle error

      }

    },

  },

};

</script>



<style scoped>

.lead-source-roi {

  margin-top: 20px;

}

</style>